const PARTICIPANT_ROLE_LABEL = {
  null: 'N/A',
  0: 'Multiple Roles',
  1: 'Professor',
  2: 'Campus Administrator',
  3: 'Department Chair',
  4: 'Department Coordinator',
  5: 'Student',
  6: 'Teaching Assistant',
};

const PARTICIPANT_OPTING_LABEL = {
  0: 'N/A',
  1: 'Opted In',
  2: 'Opted Out',
};

export const PARTICIPANT = {
  OPTING_RATE_THRESHOLD: {
    success: 100,
    error: 0,
  },
  OPTING_STATUS_LABEL_COLOR: {
    null: 'default',
    1: 'success',
    2: 'error',
  },
  OPTING_STATUS_LABEL: PARTICIPANT_OPTING_LABEL,
  OPTING_STATUS_FILTER: [1, 2, 0].map((id) => {
    return {
      id: id || 'N/A', // NOTE: This is only needed until string coercion issues is fixed on the backend
      label: PARTICIPANT_OPTING_LABEL[id],
    };
  }),
  ROLE_LABEL: PARTICIPANT_ROLE_LABEL,
  ROLE_FILTER: [5, 1, 6].map((id) => {
    return {
      id,
      label: PARTICIPANT_ROLE_LABEL[id],
    };
  }),
  ORDER_BY_OPTIONS: [
    {
      value: 'last_name,first_name',
      label: 'Last Name: A to Z',
    },
    {
      value: '-last_name,-first_name',
      label: 'Last Name: Z to A',
    },
  ],
  UPDATE_OPTING_LABEL: {
    1: 'out',
    2: 'in',
  },
  OPT_TYPES: {
    optOut: 1,
    optIn: 2,
  },
};

const SECTION_OPEN_STATUS_LABEL = {
  null: 'N/A',
  1: 'Upcoming',
  2: 'Open',
  3: 'Closed',
};

export const SECTION = {
  OPTING_RATE_THRESHOLD: {
    success: 80,
    warning: 50,
  },
  ORDER_BY_OPTIONS: [
    {
      value: 'course_name',
      label: 'Section Title: A to Z',
    },
    {
      value: '-course_name',
      label: 'Section Title: Z to A',
    },
    {
      value: '-opt_in_rate',
      label: 'Opting: High to Low',
    },
    {
      value: 'opt_in_rate',
      label: 'Opting: Low to High',
    },
  ],
  OPEN_STATUS_COLOR: {
    null: 'default',
    1: 'warning',
    2: 'success',
    3: 'error',
  },
  OPEN_STATUS_LABEL: SECTION_OPEN_STATUS_LABEL,
  OPEN_STATUS_FILTER: [2, 3, 1].map((id) => {
    return {
      id,
      label: SECTION_OPEN_STATUS_LABEL[id],
    };
  }),
};

export const DEFAULT = {
  PAGINATION: {
    LIMIT: 50,
    ROWS_PER_PAGE_OPTIONS: [10, 25, 50, 100, 500],
  },
};

const EMAIL_STATUS_LABEL = {
  10: 'Sent',
  20: 'Processed',
  30: 'Deferred',
  40: 'Delivered',
  50: 'Bounced',
  60: 'Spam',
  70: 'Other',
  80: 'Opened',
};

export const EMAIL = {
  STATUS_LABEL_COLOR: {
    10: 'error',
    20: 'error',
    30: 'error',
    40: 'error',
    50: 'error',
    60: 'error',
    70: 'error',
    80: 'success',
  },
  STATUS_LABEL: EMAIL_STATUS_LABEL,
  STATUS_FILTER: [10, 20].map((id) => {
    return {
      id,
      label: EMAIL_STATUS_LABEL[id],
    };
  }),
  ORDER_BY_OPTIONS: [
    {
      value: 'send_date',
      label: 'Date: Most Recent First',
    },
    {
      value: '-send_date',
      label: 'Date: Oldest First',
    },
  ],
};

export const ROUTER = {
  basename: '/campus-tools/campus-insights',
};
